/*
 *###############################################################################
 *Module Name                   : LocationMaster.js                            #
 *Purpose of the Module         :                                              #
 *Description of the Module     :                                              #
 *Original Author               : Chathura Prabashwara                         #
 *Date                          : Monday , Octomber 4th 2021, 10:10:07 am      #
 *Copyright © 2021 myPOS Software Solution (Pvt) Ltd.                          #
 *###############################################################################
 */

import React, { useState } from "react"
import {
    Col,
    Row,
    Button,
    Alert,
    Label
} from "reactstrap"

//**Importing required componant files   */
import DPTextBox from "../../../framework/components/DPTextBox"
import DPSwitch from "framework/components/DPSwitch"
import DPTextBoxButton from "framework/components/DPTextBoxButton"
import DPDropDown from "framework/components/DPDropDown"
getcostCodeDetails
getcostCodeDetails
import { getCompanyMaster, getLocationDetails, getPriceModDetails, getGradeDetails, getLocationGroup, getLocationSubGroup, getCurrencyDetails, getcostCodeDetails } from './LocationMasterController'
import imageExcelUpload from "../../../assets/images/Upload.png"
import imageExcelDownload from "../../../assets/images/Download.png"
import MasterUpload from "../../../assets/File/Location.xlsx";
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import LocationMasterGenStoles from "./LocationMasterGenStoles"
//**End Importing required componant files */


const LocationMasterContent = ({
    Loc_Code,
    Loc_Code_OnChange,
    Loc_Code_onKeyPress,
    Loc_Code_Enabled,
    onBlur,
    Loc_Desc,
    Loc_Desc_OnChange,
    Loc_ComCode,
    Loc_ComCode_OnChange,
    Loc_CosCode,
    Loc_CosCode_OnChange,
    Loc_LinkCode,
    Loc_LinkCode_OnChange,
    Loc_AbrCode,
    Loc_AbrCode_OnChange,
    Loc_MainLoc,
    Loc_MainLoc_OnChange,
    Loc_Grade,
    Loc_Grade_OnChange,
    Loc_Group,
    Loc_Group_OnChange,
    Loc_SubGroup,
    Loc_SubGroup_OnChange,
    Loc_Ip,
    Loc_Ip_OnChange,
    Loc_Map,
    Loc_Map_OnChange,
    Loc_Floor,
    Loc_Floor_OnChange,
    FlooronBlur,
    Loc_OpDate,
    Loc_OpDateOnChange,
    Loc_OpDate_OnBlur,
    Loc_ClDate,
    Loc_ClDateOnChange,
    Loc_OpFrom,
    Loc_OpFromOnChange,
    Loc_OpTo,
    Loc_OpToOnChange,
    Loc_PrmodOnChange,
    Loc_Prmod,
    Loc_Growth,
    Loc_GrowthOnChange,
    Loc_CurCode,
    Loc_CurCodeOnChange,
    Loc_Active_OnChange,
    Loc_Active,
    Loc_WebActive_OnChange,
    Loc_WebActive,
    Loc_Remote_OnChange,
    Loc_Remote,
    Loc_Stock_OnChange,
    Loc_Stock,
    Loc_Other,
    Loc_Other_OnChange,
    OtheronBlur,
    Loc_Total,
    Loc_Total_OnChange,
    TotalonBlur,
    ErrorMsg,
    show,
    AlertColor,
    AlertMsg,
    disabled,
    Loc_Staff,
    Loc_Staff_OnChange,
    Loc_ParkSlots,
    Loc_ParkSlots_OnChange,
    Loc_PosUnits,
    Loc_PosUnits_OnChange,
    Loc_BkUnits,
    Loc_BkUnits_OnChange,
    Loc_MobUnits,
    Loc_MobUnits_OnChange,
    Loc_ExtLiq,
    Loc_ExtLiq_OnChange,
    Loc_Liquor,
    Loc_Liquor_OnChange,
    Loc_Compete,
    Loc_Compete_OnChange,
    Loc_Cafe,
    Loc_Cafe_OnChange,
    modelOpen,
    GetSelectRow,
    modelTrigger,
    onBlur_LocClDate,
    onBlur_LocOpfrom,
    onBlur_LocOpTo,
    locTotaldisabled,
    onButtonClick,
    btnDisable,
    SearchDisable,
    showFileUpload,
    valueUpload,
    menuCode,
    stoleList,
    setStoleList,
    autoCode,
    //hide & disable fields
    hideFields,
    disabledFields,
    nullCode,
    clearData
}) => {


    const [Datatablesub, SetDatatablesub] = useState([])
    const [groupFilter, SetGroupFilter] = useState('a')

    const column = [
        {
            field: "LOC_CODE",
            title: "Code",
            align: "center",
        },
        {
            field: "LOC_DESC",
            title: "Description",
            align: "center",
        }
    ]

    //*** End of useStates */
    const ApiURL = window.Links.ApiURL
    async function tog_backdrop() {
        modelTrigger();
    }



    //default sorted method
    const defaultSorted = [{
        dataField: 'id',
        order: 'asc'
    }];


    //DropDown   State
    const [companyCode, setCompanyCode] = useState([])
    const [Price, setPrice] = useState([])
    const [mainCode, setMainCode] = useState([])
    const [Grade, SetGrade] = useState([])
    const [Group, SetGroup] = useState([])
    const [SubGroup, SetSubGroup] = useState([])
    const [currency, Setcurrency] = useState([])
    const [costCode, SetcostCode] = useState([])

    React.useEffect(async () => {
        let Data = await getCompanyMaster()
        setCompanyCode(Data)

        let DataPur = await getLocationDetails()
        setMainCode(DataPur)

        let Datalan1 = await getPriceModDetails()
        setPrice(Datalan1)

        let Data2 = await getGradeDetails()
        SetGrade(Data2)

        let Data3 = await getLocationGroup()
        SetGroup(Data3)

        let Data4 = await getLocationSubGroup()
        SetSubGroup(Data4)

        let Data5 = await getCurrencyDetails()
        Setcurrency(Data5)

        let Data6 = await getcostCodeDetails()
        SetcostCode(Data6)
    }, [])



    async function addToMaincode() {
        var newCode = await getLocationDetails()

        if (nullCode) {
            newCode.push({
                label: Loc_Desc,
                value: Loc_Code,
            })
        } else {
            newCode.push({
                label: Loc_Desc,
                value: autoCode,
            })
        }

        setMainCode(newCode)
    }


    return (
        <React.Fragment>
            <Row>
                {show ? (
                    <Alert color={AlertColor} role="alert">
                        {AlertMsg}
                        <br />
                        <small>{ErrorMsg}</small>
                    </Alert>
                ) : null}
                <Col sm={12} md={6} className="mb-4-sm">
                    <Row>
                        <Col>
                            <DPTextBoxButton
                                rowClass="mb-4-sm"
                                labelText="Code *"
                                textType="text"
                                maxLength="5"
                                value={Loc_Code}
                                onChange={Loc_Code_OnChange}
                                onKeyPress={Loc_Code_onKeyPress}
                                onBlur={onBlur}
                                disabled={disabled == true ? disabled : Loc_Code_Enabled}
                                onButtonClick={onButtonClick}
                                btnDisable={disabled == true ? disabled : btnDisable}
                                placeholder={autoCode}

                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Button
                                onClick={() => {
                                    tog_backdrop()
                                }}
                                color="success"
                                className="btn-sm"
                                disabled={SearchDisable}
                            >
                                <i
                                    className="mdi mdi-search-web"
                                    style={{ fontSize: "12px" }}
                                ></i>
                            </Button>
                            <DPSearchBoxDynamic
                                searchData={Datatablesub}
                                columns={column}
                                defaultSorted={defaultSorted}
                                mainTitle={"Location Search"}
                                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={modelOpen}
                                toggle={modelTrigger}
                                getSelect={GetSelectRow}
                                APIURL={ApiURL}
                                URLPath={"LOCATION"}
                                MenuCode={menuCode}
                                KeyVal={'LOC'}
                                searchBy={'LOC_CODE'}
                                FilterStr={groupFilter}
                            />
                        </Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_DESC") ? true : false}>
                        <Col>
                            <DPTextBox
                                rowClass="mb-4-sm"
                                labelText="Description *"
                                textType="text"
                                value={Loc_Desc}
                                onChange={Loc_Desc_OnChange}
                                disabled={disabled || disabledFields.includes("LOC_DESC")}
                                onBlur={addToMaincode}

                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_COMCODE") ? true : false}>
                        <Col>
                            <DPDropDown
                                labelText="Company *"
                                rowClass="mb-4-sm"
                                optionGroup={companyCode}
                                selectedGroup={Loc_ComCode}
                                onChange={Loc_ComCode_OnChange}
                                disabled={disabled || disabledFields.includes("LOC_COMCODE")}

                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_COSCODE") ? true : false}>
                        <Col>
                            <DPDropDown
                                labelText="Cost Code"
                                rowClass="mb-4-sm"
                                optionGroup={costCode}
                                selectedGroup={Loc_CosCode}
                                onChange={Loc_CosCode_OnChange}
                                disabled={disabled || disabledFields.includes("LOC_COSCODE")}

                            />

                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_LINKCODE") ? true : false}>
                        <Col>
                            <DPTextBox
                                rowClass="mb-4-sm"
                                labelText="Link Reference "
                                textType="text"
                                value={Loc_LinkCode}
                                onChange={Loc_LinkCode_OnChange}
                                disabled={disabled || disabledFields.includes("LOC_LINKCODE")}
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_ABRCODE") ? true : false}>
                        <Col>
                            <DPTextBox
                                rowClass="mb-4-sm"
                                labelText="Abbreviation"
                                textType="text"
                                value={Loc_AbrCode}
                                onChange={Loc_AbrCode_OnChange}
                                disabled={disabled || disabledFields.includes("LOC_ABRCODE")}

                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_MAINLOC") ? true : false}>
                        <Col>
                            <DPDropDown
                                labelText="Main Code"
                                rowClass="mb-4-sm"
                                optionGroup={mainCode}
                                selectedGroup={Loc_MainLoc}
                                onChange={Loc_MainLoc_OnChange}
                                disabled={disabled || disabledFields.includes("LOC_MAINLOC")}

                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_GRADE") ? true : false}>
                        <Col>
                            <DPDropDown
                                labelText="Grade"
                                rowClass="mb-4-sm"
                                optionGroup={Grade}
                                selectedGroup={Loc_Grade}
                                onChange={Loc_Grade_OnChange}
                                disabled={disabled || disabledFields.includes("LOC_GRADE")}

                            />

                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_GROUP") ? true : false}>
                        <Col>
                            <DPDropDown
                                labelText="Group"
                                rowClass="mb-4-sm"
                                optionGroup={Group}
                                selectedGroup={Loc_Group}
                                onChange={Loc_Group_OnChange}
                                disabled={disabled || disabledFields.includes("LOC_GROUP")}

                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_SUBGROUP") ? true : false}>
                        <Col>
                            <DPDropDown
                                labelText="Sub Group"
                                rowClass="mb-4-sm"
                                optionGroup={SubGroup}
                                selectedGroup={Loc_SubGroup}
                                onChange={Loc_SubGroup_OnChange}
                                disabled={disabled || disabledFields.includes("LOC_SUBGROUP")}

                            />

                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_IP") ? true : false}>
                        <Col>
                            <DPTextBox
                                rowClass="mb-4-sm"
                                labelText="IP Address"
                                textType="text"
                                value={Loc_Ip}
                                onChange={Loc_Ip_OnChange}
                                disabled={disabled || disabledFields.includes("LOC_IP")}

                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>

                    <Row hidden={hideFields && disabledFields.includes("LOC_FLOOR") ? true : false}>
                        <Col>
                            <DPTextBox
                                rowClass="mb-4-sm"
                                labelText="Floor Area"
                                // textType="text"
                                value={Loc_Floor}
                                onChange={Loc_Floor_OnChange}
                                disabled={disabled || disabledFields.includes("LOC_FLOOR")}
                                onBlur={FlooronBlur}
                                textAlign="right"
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_OTHERFL") ? true : false}>
                        <Col>
                            <DPTextBox
                                rowClass="mb-4-sm"
                                labelText="Other Area"
                                // textType="text"
                                value={Loc_Other}
                                onChange={Loc_Other_OnChange}
                                disabled={disabled || disabledFields.includes("LOC_OTHERFL")}
                                onBlur={OtheronBlur}
                                textAlign="right"
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_TOTAREA") ? true : false}>
                        <Col>
                            <DPTextBox
                                rowClass="mb-4-sm"
                                labelText="Total Areas"
                                // textType="text"
                                value={Loc_Total}
                                onChange={Loc_Total_OnChange}
                                disabled={locTotaldisabled || disabledFields.includes("LOC_TOTAREA")}
                                onBlur={TotalonBlur}
                                textAlign="right"
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_MAP1") ? true : false}>
                        <Col>
                            <DPTextBox
                                rowClass="mb-4-sm"
                                labelText="Google Map link"
                                textType="text"
                                value={Loc_Map}
                                onChange={Loc_Map_OnChange}
                                disabled={disabled || disabledFields.includes("LOC_MAP1")}

                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>

                </Col>
                <Col sm={12} md={5} className="mb-4-sm">
                    <Row hidden={hideFields && disabledFields.includes("LOC_STAFF") ? true : false}>
                        <Col>
                            <DPTextBox
                                rowClass="mb-4-sm"
                                labelText="Budgeted Cadre"
                                // textType="text"
                                value={Loc_Staff}
                                onChange={Loc_Staff_OnChange}
                                disabled={disabled || disabledFields.includes("LOC_STAFF")}
                                textAlign="right"
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_PARKSLOTS") ? true : false}>
                        <Col>
                            <DPTextBox
                                rowClass="mb-4-sm"
                                labelText="Car Park  "
                                // textType="text"
                                value={Loc_ParkSlots}
                                onChange={Loc_ParkSlots_OnChange}
                                disabled={disabled || disabledFields.includes("LOC_PARKSLOTS")}
                                textAlign="right"
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_POSUNITS") ? true : false}>
                        <Col>
                            <DPTextBox
                                rowClass="mb-4-sm"
                                labelText="POS Units  "
                                // textType="text"
                                value={Loc_PosUnits}
                                onChange={Loc_PosUnits_OnChange}
                                disabled={disabled || disabledFields.includes("LOC_POSUNITS")}
                                textAlign="right"
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_BKUNITS") ? true : false}>
                        <Col>
                            <DPTextBox
                                rowClass="mb-4-sm"
                                labelText="Computers  "
                                // textType="text"
                                value={Loc_BkUnits}
                                onChange={Loc_BkUnits_OnChange}
                                disabled={disabled || disabledFields.includes("LOC_BKUNITS")}
                                textAlign="right"
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_MOBUNITS") ? true : false}>
                        <Col>
                            <DPTextBox
                                rowClass="mb-4-sm"
                                labelText="Mobile Devices  "
                                // textType="text"
                                value={Loc_MobUnits}
                                onChange={Loc_MobUnits_OnChange}
                                disabled={disabled || disabledFields.includes("LOC_MOBUNITS")}
                                textAlign="right"
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>

                    <Row hidden={hideFields && disabledFields.includes("LOC_OPDATE") ? true : false}>
                        <Col>
                            <DPTextBox
                                rowClass="mb-3-sm"
                                labelText="Open Date"
                                textType="date"
                                value={Loc_OpDate}
                                onChange={Loc_OpDateOnChange}
                                disabled={disabled || disabledFields.includes("LOC_OPDATE")}
                                onBlur={Loc_OpDate_OnBlur}



                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_CLDATE") ? true : false}>
                        <Col>
                            <DPTextBox
                                rowClass="mb-3-sm"
                                labelText="Closed Date"
                                textType="date"
                                value={Loc_ClDate}
                                onChange={Loc_ClDateOnChange}
                                disabled={disabled || disabledFields.includes("LOC_CLDATE")}
                                onBlur={onBlur_LocClDate}

                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_OPFROM") ? true : false}>
                        <Col>
                            <DPTextBox
                                rowClass="mb-3-sm"
                                labelText="Open from"
                                textType="time"
                                value={Loc_OpFrom}
                                onChange={Loc_OpFromOnChange}
                                disabled={disabled || disabledFields.includes("LOC_OPFROM")}
                                onBlur={onBlur_LocOpfrom}

                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_OPTO") ? true : false}>
                        <Col>
                            <DPTextBox
                                rowClass="mb-3-sm"
                                labelText=" Close At"
                                textType="time"
                                value={Loc_OpTo}
                                onChange={Loc_OpToOnChange}
                                disabled={disabled || disabledFields.includes("LOC_OPTO")}
                                onBlur={onBlur_LocOpTo}

                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_GROWTH") ? true : false}>
                        <Col>
                            <DPTextBox
                                rowClass="mb-3-sm"
                                labelText="Anual Growth"
                                // textType="text"
                                value={Loc_Growth}
                                onChange={Loc_GrowthOnChange}
                                disabled={disabled || disabledFields.includes("LOC_GROWTH")}
                                textAlign="right"
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_CURCODE") ? true : false}>
                        <Col>

                            <DPDropDown
                                labelText="Currency Code"
                                rowClass="mb-4-sm"
                                optionGroup={currency}
                                selectedGroup={Loc_CurCode}
                                onChange={Loc_CurCodeOnChange}
                                disabled={disabled || disabledFields.includes("LOC_CURCODE")}

                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_PRMODE") ? true : false}>
                        <Col>
                            <DPDropDown
                                labelText="Price Mode"
                                rowClass="mb-4-sm"
                                optionGroup={Price}
                                selectedGroup={Loc_Prmod}
                                onChange={Loc_PrmodOnChange}
                                disabled={disabled || disabledFields.includes("LOC_PRMODE")}

                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                    </Row>
                    <Row hidden={hideFields && disabledFields.includes("LOC_ACTIVE") ? true : false}>
                        <Col md={5}>

                            <Row>
                                <Col md={4}>
                                    <DPSwitch
                                        rowClass={"mb-4-sm"}
                                        height={23}
                                        handleDiameter={15}
                                        onChange={Loc_Active_OnChange}
                                        checked={Loc_Active}
                                        disabled={disabled || disabledFields.includes("LOC_ACTIVE")}
                                    />
                                </Col>
                                <Col style={{ textAlign: "left" }}>
                                    <Label
                                        htmlFor="example-text-input"
                                        className={`col-md-12 col-form-label-sm`}
                                    >
                                        Active
                                    </Label>
                                </Col>
                            </Row>
                            <Row hidden={hideFields && disabledFields.includes("LOC_WEBACTIVE") ? true : false}>
                                <Col md={4}>
                                    <DPSwitch
                                        rowClass={"mb-4-sm"}
                                        height={23}
                                        handleDiameter={15}
                                        onChange={Loc_WebActive_OnChange}
                                        checked={Loc_WebActive}
                                        disabled={disabled || disabledFields.includes("LOC_WEBACTIVE")}
                                    />
                                </Col>
                                <Col style={{ textAlign: "left" }}>
                                    <Label
                                        htmlFor="example-text-input"
                                        className={`col-md-12 col-form-label-sm`}
                                    >
                                        Web Sales Active
                                    </Label>
                                </Col>
                            </Row>
                            <Row hidden={hideFields && disabledFields.includes("LOC_REMOTE") ? true : false}>
                                <Col md={4}>
                                    <DPSwitch
                                        rowClass={"mb-4-sm"}
                                        height={23}
                                        handleDiameter={15}
                                        onChange={Loc_Remote_OnChange}
                                        checked={Loc_Remote}
                                        disabled={disabled || disabledFields.includes("LOC_REMOTE")}
                                    />
                                </Col>
                                <Col style={{ textAlign: "left" }}>
                                    <Label
                                        htmlFor="example-text-input"
                                        className={`col-md-12 col-form-label-sm`}
                                    >
                                        Remote Status
                                    </Label>
                                </Col>
                            </Row>
                            <Row hidden={hideFields && disabledFields.includes("LOC_STOCK") ? true : false}>
                                <Col md={4}>
                                    <DPSwitch
                                        rowClass={"mb-4-sm"}
                                        height={23}
                                        handleDiameter={15}
                                        onChange={Loc_Stock_OnChange}
                                        checked={Loc_Stock}
                                        disabled={disabled || disabledFields.includes("LOC_STOCK")}
                                    />
                                </Col>
                                <Col style={{ textAlign: "left" }}>
                                    <Label
                                        htmlFor="example-text-input"
                                        className={`col-md-12 col-form-label-sm`}
                                    >
                                        Stock Status
                                    </Label>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={6}>
                            <Row hidden={hideFields && disabledFields.includes("LOC_CAFE") ? true : false}>
                                <Col md={3}>

                                    <DPSwitch
                                        rowClass={"mb-4-sm"}
                                        height={23}
                                        handleDiameter={15}
                                        onChange={Loc_Cafe_OnChange}
                                        checked={Loc_Cafe}
                                        disabled={disabled || disabledFields.includes("LOC_CAFE")}
                                    />
                                </Col>
                                <Col style={{ textAlign: "left" }}>
                                    <Label
                                        htmlFor="example-text-input"
                                        className={`col-md-12 col-form-label-sm`}
                                    >
                                        Cafe Function
                                    </Label>
                                </Col>
                            </Row>
                            <Row hidden={hideFields && disabledFields.includes("LOC_COMPETE") ? true : false}>
                                <Col md={3}>
                                    <DPSwitch
                                        rowClass={"mb-4-sm"}
                                        height={23}
                                        handleDiameter={15}
                                        onChange={Loc_Compete_OnChange}
                                        checked={Loc_Compete}
                                        disabled={disabled || disabledFields.includes("LOC_COMPETE")}
                                    />
                                </Col>
                                <Col style={{ textAlign: "left" }}>
                                    <Label
                                        htmlFor="example-text-input"
                                        className={`col-md-12 col-form-label-sm`}
                                    >
                                        Competitor Outlets
                                    </Label>
                                </Col>
                            </Row>
                            <Row hidden={hideFields && disabledFields.includes("LOC_LIQUOR") ? true : false}>
                                <Col md={3}>
                                    <DPSwitch
                                        rowClass={"mb-4-sm"}
                                        height={23}
                                        handleDiameter={15}
                                        onChange={Loc_Liquor_OnChange}
                                        checked={Loc_Liquor}
                                        disabled={disabled || disabledFields.includes("LOC_LIQUOR")}
                                    />
                                </Col>
                                <Col style={{ textAlign: "left" }}>
                                    <Label
                                        htmlFor="example-text-input"
                                        className={`col-md-12 col-form-label-sm`}
                                    >
                                        Liquor Available
                                    </Label>
                                </Col>
                            </Row>
                            <Row hidden={hideFields && disabledFields.includes("LOC_EXTLIQUOR") ? true : false}>
                                <Col md={3}>
                                    <DPSwitch
                                        rowClass={"mb-4-sm"}
                                        height={23}
                                        handleDiameter={15}
                                        onChange={Loc_ExtLiq_OnChange}
                                        checked={Loc_ExtLiq}
                                        disabled={disabled || disabledFields.includes("LOC_EXTLIQUOR")}
                                    />
                                </Col>
                                <Col style={{ textAlign: "left" }}>
                                    <Label
                                        htmlFor="example-text-input"
                                        className={`col-md-12 col-form-label-sm`}
                                    >
                                        3rd Party Liquor
                                    </Label>
                                </Col>
                            </Row>
                        </Col>
                        <Row hidden={hideFields && disabledFields.includes("LOC_RENTALS") ? true : false}>
                            <LocationMasterGenStoles disabled={disabled || disabledFields.includes("LOC_RENTALS")} stoleList={stoleList} setStoleList={setStoleList} propAUTO_CODE={autoCode} propLR_LOCCODE={Loc_Code} clearData={clearData} />
                        </Row>
                    </Row>
                </Col>
                <Col sm={12} md={1} className="mb-4-sm">
                    <ul className="import-export-button-block" style={{ display: "flex", flexFlow: "row", flexWrap: "wrap", padding: "0px", justifyContent: "end" }}>
                        <li className="import-export-button" style={{ display: "block" }}>
                            <input
                                id="file"
                                type="file"
                                onChange={showFileUpload}
                                value={valueUpload}
                                disabled={Loc_Code_Enabled}
                                accept=".xlsx, .xls, .csv"
                                style={{ display: "none" }}
                            />

                            <label htmlFor="file" title="Master Excel Upload" style={{ cursor: "pointer", opacity: Loc_Code_Enabled == true ? "0.5" : "1" }}>
                                <span >
                                    <img class="manImg" src={imageExcelUpload} style={{ width: "40px", height: "40px" }}></img>
                                </span>
                            </label></li>

                        <li className="import-export-button" style={{ display: "block" }}>
                            <a href={MasterUpload} download="Master File Upload" data-tip title="Master excel format download"
                                style={{ pointerEvents: Loc_Code_Enabled ? 'none' : '', }} >
                                <img class="manImg" src={imageExcelDownload} style={{ width: "40px", height: "40px", opacity: Loc_Code_Enabled == true ? "0.5" : "1" }}></img>
                            </a></li>
                    </ul>
                </Col>

            </Row>
        </React.Fragment>
    )
}
export default LocationMasterContent
